"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyFormatter = void 0;
var isNil_1 = __importDefault(require("lodash/fp/isNil"));
var isNaN_1 = __importDefault(require("lodash/fp/isNaN"));
var identity_1 = __importDefault(require("lodash/fp/identity"));
var interpolate_1 = __importDefault(require("interpolate"));
var DEFAULT_FLOAT_LENGTH = 2;
/**
 * Example: { number: '123456', separationCount: 3, separator: ',' }
 * 1. Split number string to array. ['1', '2', '3', '4', '5', '6']
 * 2. Reverse the array. ['6', '5', '4', '3', '2', '1']
 * 3. Add separator to item by separationCount. ['6', '5', ',4', '3', '2', '1']
 * 4. Reverse again. ['1', '2', '3', ',4', '5', '6']
 * 5. Join the array to string. '123,456'
 */
var addSeparatorsForIntPart = function (number, separationCount, separator) { return number
    .split('')
    .reverse()
    .map(function (n, i) { return (i !== number.length - 1 && i % separationCount === separationCount - 1
    ? separator
    : '') + n; })
    .reverse()
    .join(''); };
var addSeparators = function (number, separationCount, separator) {
    var numberStrArr = number.toString().split('.');
    var integerPart = addSeparatorsForIntPart(numberStrArr[0].replace(/-/, ''), separationCount, separator);
    var floatPart = numberStrArr.length > 1 ? ".".concat(numberStrArr[1]) : '';
    return "".concat(integerPart).concat(floatPart);
};
/**
 * @deprecated Use currency/format instead.
 * */
var currencyFormatter = function (formatConfig) { return function (amount, amountFormatter) {
    if (amountFormatter === void 0) { amountFormatter = identity_1.default; }
    var template = formatConfig.template, integerOnly = formatConfig.integerOnly, separationCount = formatConfig.separationCount, separator = formatConfig.separator, negativeMark = formatConfig.negativeMark;
    var number = integerOnly
        ? parseInt(amount, 10)
        : parseFloat(amount).toFixed(DEFAULT_FLOAT_LENGTH);
    if ((0, isNil_1.default)(number) || (0, isNaN_1.default)(Number(number))) {
        return '';
    }
    var structuredAmount = addSeparators(number, separationCount, separator);
    return (0, interpolate_1.default)(template, {
        amount: amountFormatter(structuredAmount),
        negative: parseFloat(amount) < 0 ? negativeMark : '',
    });
}; };
exports.currencyFormatter = currencyFormatter;
exports.default = exports.currencyFormatter;
